import { Card, HorizontalCardGroup } from '@ps/sports-ui-component-library';
import React from 'react';
import { useSelector } from 'react-redux';

import { MarketTemplate, OddsBoostEventLink, OddsBoostPanelHeader } from '@swf/sports/components';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';

import { useSportsLandingPageWidget } from '../../model';

import styles from './PopularOddsBoostEvents.scss';

const PopularOddsBoostEvents: React.FC = () => {
  const { widgetSelect } = useSportsLandingPageWidget();
  const markets = useSelector(widgetSelect.markets);
  const events = useSelector(widgetSelect.events);
  const eventTypes = useSelector(widgetSelect.eventTypes);
  const competitions = useSelector(widgetSelect.competitions);

  const popularOddsBoostEvents = useSelector(widgetSelect.popularOddsBoostEvents);

  if (!popularOddsBoostEvents.length) {
    return null;
  }

  return (
    <>
      <OddsBoostPanelHeader />
      <HorizontalCardGroup className={styles.cardGroup}>
        {popularOddsBoostEvents.map((oddsBoostItem) => {
          if (oddsBoostItem.template.templateId !== 'ODDS_BOOST') return null;

          const { marketId } = oddsBoostItem.template;

          const market = markets[marketId];

          if (!market) return null;

          const event = events[market.eventId];
          const eventType = eventTypes[market.eventTypeId];
          const competition = market.competitionId ? competitions[market.competitionId] : undefined;

          if (!eventType) return null;

          return (
            <Card
              key={`${oddsBoostItem.template.marketId}-${oddsBoostItem.template.templateId}`}
              className={styles.card}
              data-testid="popular-odds-boost-events-card"
            >
              <OddsBoostEventLink
                event={event}
                market={market}
                eventTypeSlug={eventType.eventTypeSlug}
                competitionSlug={competition?.competitionSlug}
              />
              <div>
                <MarketTemplate
                  marketId={market.marketId}
                  templateId={oddsBoostItem.template.templateId}
                />
              </div>
            </Card>
          );
        })}
      </HorizontalCardGroup>
    </>
  );
};

export default () => (
  <SportsComponent name="Sports Popular Odds Boost Events Component">
    <PopularOddsBoostEvents />
  </SportsComponent>
);
